import QuestionUrlOnboarding from './QuestionUrlOnboarding';

export default QuestionUrlOnboarding;
